module.exports = __webpack_public_path__ + "static/img-tuning-94bcbefd0060ca75f23448d4bf7e391f.png";